export const dateStyle = {
  ".MuiInputBase-root": {
    background: "transparent",
    marginRight: "10px",
    disableUnderline: true,
    maxWidth: "160px",
  },
  ".MuiFormLabel-root": {
    color: "#94BA33",
  },
  ".MuiInputBase-input": {
    color: "#94BA33",
    fontSize: "0.875rem",
    fontWeight: 500,
    padding: "4px 8px",
    backgroundColor: "transparent",
    height: "30px !important",
  },
  "&:focus": {
    background: "transparent !important",
  },
  ".MuiSvgIcon-root": {
    color: "#94BA33",
  },
};
